/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveVaultMemberList } from '../../models/remove-vault-member-list';

export interface VaultGetRemoveMemberList$Params {

/**
 * GUID of the vault
 */
  vaultId: string;
}

export function vaultGetRemoveMemberList(http: HttpClient, rootUrl: string, params: VaultGetRemoveMemberList$Params, context?: HttpContext): Observable<StrictHttpResponse<RemoveVaultMemberList>> {
  const rb = new RequestBuilder(rootUrl, vaultGetRemoveMemberList.PATH, 'get');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RemoveVaultMemberList>;
    })
  );
}

vaultGetRemoveMemberList.PATH = '/vault/{vaultId}/remove-member/list';
